import {rootState} from '@mintdata-wsp/common/state/RootState';
import {FlowTopBarState} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';
import {ScreenRegion} from '@mintdata-wsp/common/state/ui/visualDesigner/workbench/layout/Perspective';
import {SectionVisibility} from '@mintdata-wsp/common/state/ui/visualDesigner/workbench/PanelState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {action, reaction} from 'mobx';

export class FlowTopBarController
{
    public init()
    {
        this._listenForFlowEditorWonderBarDrag();
    }

    private _listenForFlowEditorWonderBarDrag()
    {
        const {flowCanvas} = controllers.ui;

        reaction(
            () => flowCanvas.isDragFromWonderbarInProgress(),
            (isFlowEditorDragInProgress) =>
            {
                if( isFlowEditorDragInProgress )
                {
                    this.setWonderBarVisibility(false);
                }
            });
    }

    public isPropertiesPanelVisible():boolean
    {
        const perspective = controllers.ui.perspective.getActivePerspective();
        const section = perspective.findSection(ScreenRegion.East);

        return section.visibility === SectionVisibility.Visible;
    }

    @action
    public setPropertiesPanelVisibility(visibility:boolean):void
    {
        const perspective = controllers.ui.perspective.getActivePerspective();
        const section = perspective.findSection(ScreenRegion.East);

        section.visibility = visibility ? SectionVisibility.Visible : SectionVisibility.Hidden;
    }

    @action
    public togglePropertiesPanelVisibility():void
    {
        const toggledValue = !this.isPropertiesPanelVisible();

        this.setPropertiesPanelVisibility(toggledValue);
    }

    public isWonderBarVisible():boolean
    {
        const state = this._getState();

        return state.isWonderBarVisible;
    }

    @action
    public setWonderBarVisibility(visibility:boolean):void
    {
        const state = this._getState();

        state.isWonderBarVisible = visibility;

        /**
         * todo:
         * Surface/Flow Wonderbar filter functionality should be changed.
         * Make filtered items state to be computed.
         */
        if( visibility === false )
        {
            controllers.ui.flowComponentsPanel.clearFilterString();
        }
    }

    @action
    public toggleWonderBarVisibility():void
    {
        const state = this._getState();

        const toggledValue = !state.isWonderBarVisible;
        this.setWonderBarVisibility(toggledValue);
    }

    public getWonderBarDomRef():HTMLElement | null
    {
        const state = this._getState();

        return state.wonderBarDomRef;
    }

    @action
    public setWonderBarDomRef(ref:HTMLElement | null):void
    {
        const state = this._getState();

        state.wonderBarDomRef = ref;
    }

    private _getState():FlowTopBarState
    {
        return rootState.ui.visualDesigner.flow.topBar;
    }
}
